<template>
    <div class="treasurehunt default-theme">
        
        <splitpanes  id="page-wrap" class="">
            <pane min-size="30" size="65">
                <div class="map-edit-container" :class="{'embed':embed}">
                    <l-map
                        :zoom="zoom"
                        :center="center"
                        :bounds="mapBounds"
                        ref="editMap"
                        :options="{
                            zoomControl: false,
                            minZoom: 2,
                            maxNativeZoom: 18,
                            maxZoom: 24,
                            editable: true,
                        }"
                        @click="getMapClickPosition"
                        style="z-index: 19"
                        :class="{'ios-tablet':isTabletIos}"
                    >
                        <l-control-zoom position="topright"></l-control-zoom>
                        
                        <l-tile-layer
                            v-for="tileProvider in availiableMapLayers"
                            :key="tileProvider.name"
                            :name="$t(tileProvider.name)"
                            :visible="true"
                            :url="tileProvider.url"
                            :attribution="tileProvider.attribution"
                            :layer-type="tileProvider.type"
                            :options="tileProvider.options"
                        />
                        <l-control-layers v-if="needWays" position="bottomright" :hideSingleBase="true" :collapsed="false"></l-control-layers>

                        <div v-if="items.length">
                            <div v-for="object in items" :key="object._id">
                                <div v-if="object.location">
                                    <l-marker
                                        v-if="
                                            (!activeObject ||
                                                object._id != activeObject._id) &&
                                            object.location
                                        "
                                    
                                        :lat-lng="object.location | toLatLon"
                                        @click="openObjectFromPoint(object)"
                                    >
                                        <l-icon v-if="highlightedMarker==object._id || selectedObjectMarker == object._id"
                                            :icon-size="dynamicSize"
                                            :icon-anchor="dynamicAnchor"
                                            icon-url="/img/map-icons/00_clue_select.svg"
                                        />

                                        <l-icon v-else
                                            :icon-size="dynamicSize"
                                            :icon-anchor="dynamicAnchor"
                                            icon-url="/img/map-icons/00_clue.svg"
                                            
                                        />
                                    </l-marker>

                                    <l-marker
                                        v-if="
                                            !editionEnabled &&
                                            activeObject &&
                                            object._id == activeObject._id &&
                                            object.location
                                        "
                                        :lat-lng="object.location | toLatLon"
                                        @click="openObject(object)"
                                    >
                                        <l-icon v-if="highlightedMarker==object._id || selectedObjectMarker == object._id"
                                            :icon-size="dynamicSize2"
                                            :icon-anchor="dynamicAnchor2"
                                            icon-url="/img/map-icons/00_clue.svg"
                                        />

                                        <l-icon v-else
                                            :icon-size="dynamicSize"
                                            :icon-anchor="dynamicAnchor"
                                            icon-url="/img/map-icons/00_point_edit.svg"
                                        />

                                        <l-tooltip :options="tooltipOptions">
                                            {{ object.title || object.description }}
                                        </l-tooltip>
                                    </l-marker>
                                </div>
                            </div>
                        </div>

                        <div v-if="pointDraft">
                            <l-marker
                                :lat-lng="pointDraft.location | toLatLon"
                                :key="pointDraft._id"
                                :draggable="true"
                                @dragend="updateDraftPosition"
                            >
                                <l-icon
                                    :icon-size="dynamicSize"
                                    :icon-anchor="dynamicAnchor"
                                    icon-url="/img/map-icons/00_point_edit.svg"
                                />
                            </l-marker>
                        </div>
                    </l-map>
                </div>
            </pane>
            <pane min-size="35" max-size="70" class="has-background-pale-grey">
                <div v-if="items.length" class="lb-treasurehunt-cards-container has-background-pale-grey">
                    <project-edit-treasurehunt-cards 
                    :items="items"
                    :selected-object="selectedObject"
                    :canCreateOrEditObjects="canCreateOrEditObjects"
                    :isSessionActive="isSessionActive"
                    :editionEnabled="editionEnabled"
                    :creationEnabled="creationEnabled"
                    :canCreateObject="canCreateObject"
                    @open-object="openObject"
                    @add="addObject"
                    @hover="highlightMarker"
                    @leave="unHighlightMarker"
                    @edit-object="editObject"

                    @view="showPreview"
                    @remove="deleteObject"
                    />
                </div>
                
            </pane>
        </splitpanes>
    </div>
</template>

<script>
import AppPageError from '@/components/AppPageError';
import _ from 'underscore';
import * as L from 'leaflet';
require('leaflet.path.drag');
require('leaflet-editable');
import { TILE_PROVIDERS, DEFAULT_TILE_PROVIDER } from '@/lib/constants';
import {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LPopup,
    LControl,
    LControlLayers,
    LControlZoom,
    LTooltip
} from 'vue2-leaflet';

import ProjectEditTreasurehuntCards from '@/components/ProjectEditTreasurehuntCards';
import { Splitpanes, Pane } from 'splitpanes';
import { isTablet,isMobileOnly,isAndroid,isIOS } from 'mobile-device-detect';
export default {
    name: 'ProjectContentTreasureHunt',
    components: {
        AppPageError,
        LMap,
        LTileLayer,
        LMarker,
        LIcon,
        LPopup,
        LControl,
        LControlLayers,
        LTooltip,
        LControlZoom,
        Splitpanes,
        Pane,
        ProjectEditTreasurehuntCards
    },
    data() {
        return {
            embed: this.$route.meta.embed,
            activeSession: undefined,
            session: {},
            map: {},
            tileProviders: TILE_PROVIDERS,
            defaultTileProvider: DEFAULT_TILE_PROVIDER,
            tooltipOptions: { direction: 'top',offset: L.point(0, -30) },
            iconSize: 32,
            zoom: 6,
            center: [40, -2],
            showActiveSession: false,
            showSessionList: false,
            showSessionDetails: false,
            isTabletIos: isTablet&&isIOS,
        };
    },
    props: {
        ///projectId: { type: String, default: undefined },
        items: {
            type: Array,
            default: () => {
                return [];
            },
        },
        pointDraft:{
            type: Object,
            default: undefined
        },
        mapPositionActive: { type: Boolean, default: false },
        creationEnabled: { type: Boolean, default: false },
        editionEnabled: { type: Boolean, default: false },
        activeObject: {type: Object, default: undefined },
        highlightedMarker: {type: String, default: "" },
        selectedObjectMarker: {type: String, default: "" },
        selectedObject: {type: String, default: "" },
        sessionStarted: { type: Boolean, default: false },
        sessionPaused: { type: Boolean, default: false },
        sessionStopped: { type: Boolean, default: false },
        canCreateObject: { type: Boolean, default: false },
        needWays: { type: Boolean, default: false },

    },
    filters: {
        toLatLon(location) {
            let latLon = [location.latitude, location.longitude];
            // console.log(latLon);
            return latLon;
        },
    },
    computed: {
        dynamicSize() {
            return [this.iconSize, this.iconSize * 1.15];
        },
        dynamicAnchor() {
            return [this.iconSize / 2, this.iconSize * 1.15];
        },
        mapBounds() {
            let bounds = [];
            
                if (this.items.length) {
                    // console.log("setting map bounds")
                    this.items.forEach((element) => {
                        // console.log(element.location);
                        
                        if (element.location) {
                            bounds.push(
                                this.$options.filters.toLatLon(element.location)
                            );
                            
                        }
                    });
                } else {
                    bounds.push([42.38, 3.12], [40.87, -0.83]);
                }
            // console.log('bounds', bounds);
            if(!bounds.length){
                // console.log("no valid bounds. Assign defaults");
                bounds.push([42.38, 3.12], [40.87, -0.83]);
            }else if(bounds.length<2){
                let new_latitude  = bounds[0][0]  + (0.10 / ((2 * Math.PI / 360) * 6378.137));
                let new_longitude = bounds[0][1] + (0.10 / ((2 * Math.PI / 360) * 6378.137)) / Math.cos( bounds[0][0] * Math.PI/180);
                bounds.push(
                    this.$options.filters.toLatLon({'latitude':new_latitude,'longitude':new_longitude})
                );
                let new_latitude2  = bounds[0][0]  - (0.10 / ((2 * Math.PI / 360) * 6378.137));
                let new_longitude2 = bounds[0][1] - (0.10 / ((2 * Math.PI / 360) * 6378.137)) / Math.cos( bounds[0][0] * Math.PI/180);
                bounds.push(
                    this.$options.filters.toLatLon({'latitude':new_latitude2,'longitude':new_longitude2})
                );
            }
            return L.latLngBounds(bounds);
        },
        mapProvider() {
            if (this.project.mapProvider) {
                return _.findWhere(this.tileProviders, {
                    name: this.project.mapProvider,
                });
            }
            return this.defaultTileProvider;
        },
        availiableMapLayers(){
            let layers = [];
            layers.push(this.mapProvider);
            let overlayLayers = _.where(this.tileProviders, {
                    type: 'overlay',
                });
            overlayLayers.forEach(element => {
                layers.push(element);
            });
            
            // console.log(layers)
            return layers
        },
        project() {
            return this.$store.getters.project;
        },
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        canCreateOrEditObjects(){
            return (!this.sessionStarted || (this.sessionStarted && this.sessionPaused)) && 
            ((this.isLoggedIn && !this.$store.getters.isAnonymous && this.project.accessLevel!='read') || (this.project.allowAnonymous=='true' && this.$store.getters.isAnonymous && this.project.defaultPermission!='read'));
        },
        isSessionActive(){
            return this.sessionStarted && !this.sessionPaused;
        },
    },
    watch: {
        pointDraft: {
            handler: function(){
                if(this.pointDraft && !this.editionEnabled){
                    // console.log(this.pointDraft)
                    this.map.setView(this.$options.filters.toLatLon(this.pointDraft.location), 19);
                }
            },
            immediate: true,
            deep: true,
        },
        mapPositionActive: {
            handler: function () {
                if (this.mapPositionActive && !this.pointDraft) {
                    this.$refs.editMap.$el.classList.add('map-workshop-cursor');
                }
            },
            immediate: true,
        },
        /*needWays: {
            handler: function () {
                console.log("need ways", this.needWays)
                if (this.needWays) {
                    setTimeout(() => {
                    console.log()
                this.map.invalidateSize();
            }, 500);
               }
            },
            immediate: true,
        }*/
    },
    created() {
        // window.addEventListener('resize', this.onResize);
    },
    destroyed() {
        // window.removeEventListener('resize', this.onResize);
    },
    mounted: function () {
        delete L.Icon.Default.prototype._getIconUrl;
        L.Icon.Default.mergeOptions({
            iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
            iconUrl: require('leaflet/dist/images/marker-icon.png'),
            shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        });

        this.$nextTick(() => {
            this.map = this.$refs.editMap.mapObject;
            this.map.fitBounds(this.mapBounds)
            setTimeout(() => {
                this.map.invalidateSize();
            }, 500);
        });
    },
    methods: {
        openObject(object) {
            if(this.editionEnabled || this.creationEnabled){
                return;
            }
            // console.log("opening object");
            this.$emit('show',object);
        },
        updateDraftPosition(e) {
            // console.log(e.target._latlng);
            this.$emit('updatePointDraft',{
                location: {
                    latitude: e.target._latlng.lat,
                    longitude: e.target._latlng.lng,
                },
            })
        },
        getMapClickPosition(e) {
            // console.log("map position active? ",this.mapPositionActive)
            if (this.mapPositionActive) {
                this.$emit('addPoint',{ lat: e.latlng.lat, lon: e.latlng.lng });
                this.$refs.editMap.$el.classList.remove('map-workshop-cursor');
            }
        },
        onChangeReceived(e) {
            // console.log("on change recived")
            const data = JSON.parse(e.data);
            switch (data.type) {
                case 'UPDATE':
                case 'NEW_COMMENT':
                    this.$store.commit('UPDATE_OBJECT', data.object);
                    break;
                case 'CREATE':
                    this.$store.commit('ADD_OBJECT_TO_PROJECT', data.object);
                    break;
                case 'NEW_PROJECT_COMMENT':
                    this.$store.commit('ADD_COMMENT_TO_PROJECT', data.object);
                    break;
                case 'LIKE_PROJECT_COMMENT':
                    this.$store.commit('UPDATE_COMMENT', {
                        _id: data.object._id,
                        comment: data.object,
                    });
                    break;
                case 'NEW_PROJECT_CHANGE':
                    this.$store.commit('ADD_CHANGE_TO_PROJECT', data.object);
                    break;
                case 'DELETE_OBJECT':
                    this.$store.commit('DELETE_OBJECT', data.object);
                    break;
                case 'NEW_ACTIVE_SESSION':
                    this.$store.commit('ADD_ACTIVE_SESSION_TO_PROJECT', data.object);
                    if(this.project.activeSession && !this.session.length){
                        this.fetchSession();
                    }
                    break;
                case 'PAUSE_ACTIVE_SESSION':
                    if(this.session && !this.session.isPaused){
                        this.fetchSession();
                    }
                    break;
                case 'CONTINUE_ACTIVE_SESSION':
                    if(this.session && this.session.isPaused){
                        this.fetchSession();
                    }
                    
                    break;
                case 'REMOVE_ACTIVE_SESSION':
                    this.$store.commit('REMOVE_ACTIVE_SESSION_TO_PROJECT');
                    if(this.session){
                        this.session = {};
                        this.$store.dispatch('cleanSession');
                    }
                    
                    break;
                default:
                    console.log('unhandled event ', data.type || data.message);
            }
        },
        addObject(objects){
            // console.log("adding object")
            this.$emit('addTreasurehuntObject',objects)
        },
        editObject(object){
            // console.log("editing object")
            this.$emit("editTreasurehuntObject",object)
        },
        deleteObject(object) {
            // console.log('delete object')
            this.$emit("deleteTreasurehuntObject",object)
        },
        showPreview(data){
            this.$emit('showTreasurehuntPreview',data)
        },
        highlightMarker(e){
            this.$emit('highlightMarker',e._id);
        },
        unHighlightMarker(e){
            this.$emit('highlightMarker',"");
        },
        openObjectFromPoint(object){
            // console.log("open disabled");
        },
        /*onResize(e) {
            if(e.target.innerWidth<1124){
                this.$emit('tooSmall',true)
            }else{
                this.$emit('tooSmall',false)
            }
        },*/
    },
};
</script>


<style scoped lang="css">
@import '~leaflet/dist/leaflet.css';
@import '~tippy.js/dist/tippy.css';
@import '../assets/css/tippylabylok.css';
@import '~leaflet-distortableimage/dist/vendor.css';
@import '~leaflet-distortableimage/dist/leaflet.distortableimage.css';
@import '../assets/css/map-sidebar.css';
@import '~splitpanes/dist/splitpanes.css';
.treasurehunt{
    background-color: #FFFFFF;
}
.splitpanes .splitpanes__splitter {
    background-color: #fff;
    box-sizing: border-box;
    position: relative;
    flex-shrink: 0;
}
.lb-treasurehunt-cards-container {
    max-height: calc(100vh - 7.7rem);
    overflow-y: auto;
    min-height: calc(100vh - 7.7rem);
}

</style>
